<template>
    <yams-template>
        <template #header>
            <div class="mr-5">
                <h4 class="text-primary font-weight-bold">Locations ({{ courses.length }})</h4>
            </div>
            <div class="mr-4">
                <NavOperations></NavOperations>
            </div>
        </template>
        <template #content>
            <div class="container">
                <form class="form-inline mb-4" @submit.prevent="changePeriod()">
                    <input class="form-control form-control-sm" type="month" id="start" name="start" min="2018-03"
                        v-model="form.period" />
                    <button type="submit" class="ml-2 btn btn-sm btn-primary">
                        <i class="fa-solid fa-magnifying-glass"></i> Charger 
                    </button>
                </form>
                <ProgressBar v-if="isLoading === true" mode="indeterminate" style="height: 6px; margin-bottom: 10px;"></ProgressBar>
                <p v-if="isEmpty == true" class="text-center"> Vous n'avez pas de course ce mois</p>
                <div class="card mb-3 shadow-2 " v-for="course in courses" :key="course.id"
                    @click="openShowModal(course)">
                    <div class=" card-body">
                        <div class="row">
                            <div class="col-md">
                                <p class="text-secondary">Code</p>
                                <strong>{{ course.code }}</strong>
                            </div>
                            <div class="col-md">
                                <p class="text-secondary">Véhicule</p>
                                <strong>{{ course.vehicule_plaque }}</strong>
                            </div>
                            <div class="col-md-4 text-center">
                                <p class="text-secondary">Trajet</p>
                                <strong>{{ course.adresse_chargement }} ({{ formatDate(course.date_chargement) }})</strong> - 
                                <strong>{{course.adresse_dechargement }}</strong>
                                <strong v-if="course.date_dechargement">({{ formatDate(course.date_dechargement) }})</strong> 
                            </div>
                            <div class="col-md">
                                <p class="text-secondary">Montant</p>
                                <strong>{{ formatPriceWithDevise(course.montant) }}</strong>
                            </div>
                            <div class="col-md">
                                <p class="text-secondary">Etat</p>
                                <strong v-if="course.statut == 'Annulé'" class="p-2 rounded-pill badge badge-danger">{{
                                    course.statut }}</strong>
                                <strong v-else-if="course.statut == 'Terminé'"
                                    class="p-2 rounded-pill badge badge-success">{{ course.statut }}</strong>
                                <strong v-else-if="course.statut == 'Programmé'"
                                    class="p-2 rounded-pill badge badge-info">{{ course.statut }}</strong>
                                <strong v-else class="p-2 rounded-pill badge badge-secondary ">{{ course.statut }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </yams-template>
</template>

<script>
import moment from 'moment'
import { defineComponent, defineAsyncComponent } from 'vue';
import NavOperations from '../NavOperations.vue';
const ShowCourseVue = defineAsyncComponent(() => import('@/views/operations/courses/ShowCourse.vue'));
export default defineComponent({
    name: 'IndexCourse',
    components: { NavOperations },
    data() {
        return {
            isLoading: false,
            url: '/api/courses',
            isEmpty: false,
            coursesUrl: '/api/courses?req_period=' + moment().format('YYYY-MM'),
            form: {
                period: moment().format('YYYY-MM'),
            },
            courses: []
        };
    },
    mounted() {
        this.getCourses()
    },
    methods: {
        formatDate(val) {
            if (val) return moment(String(val)).format('DD/MM/YYYY')
        },
        formatPriceWithDevise(val) {
            if (val) return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'XAF' }).format(val)
        },
        changePeriod() {
            this.isEmpty = false
            this.coursesUrl = this.url + '?req_period=' + this.form.period
            this.getCourses()
        },
        getCourses() {
            this.isLoading = true
            this.axios.get(this.coursesUrl).then((response) => {
                this.courses = response.data.data
                if (response.data.data.length < 1) {
                    this.isEmpty = true
                }
                this.isLoading = false
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        
        openShowModal(objData) {
            this.$dialog.open(ShowCourseVue, {
                props: {
                    header: "Course ID" + objData.id,
                    style: {
                        width: '60vw'
                    },
                    modal: true
                },
                data: objData
            });
        }
    }
});
</script>

<style scoped>
.card {
  cursor: pointer;
}
</style>